import { PaymentReceiversPeriodsService_paymentReceiverPeriodsVersionServiceGetPaymentChannelPeriods } from '@festina/moneyout-general-types/moneyout/hooks/PaymentReceiversPeriodsService_paymentReceiverPeriodsVersionServiceGetPaymentChannelPeriods'

export const useFetchPaymentChannelPeriods =
  PaymentReceiversPeriodsService_paymentReceiverPeriodsVersionServiceGetPaymentChannelPeriods.useSuspenseQuery
